import {validateField, submitFields, clearFields} from './helpers/form'
import {
  FETCH_USER_EDIT_DATA_SUCCESS,
  VALIDATE_USER_EDIT_FIELD,
  SUBMIT_USER_EDIT_FIELDS,
  CLEAR_USER_EDIT_FIELDS
} from '../../../actions/pages/user-page'

export function userEditForm(
  state = {
    valid: false,
    fields: [
      {
        name: 'UserPrincipalName',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'User name',
          required: true
        }
      },
      {
        name: 'IsActive',
        value: '',
        errors: [],
        rules: {
          title: 'Active'
        }
      },
      {
        name: 'FirstName',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'First name',
          required: true
        }
      },
      {
        name: 'LastName',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Last name',
          required: true
        }
      },
      {
        name: 'Email',
        value: '',
        type: 'email',
        errors: [],
        rules: {
          title: 'Email',
          required: true
        }
      },
      {
        name: 'Roles',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Roles',
          required: true
        }
      }
    ]
  },
  action
) {
  switch (action.type) {
    case FETCH_USER_EDIT_DATA_SUCCESS: {
      let fields = state.fields.map((field) => {
        let newValue;
        Object.entries(action.data).forEach(([key, value]) => {
          if (field.name === key){
            newValue = value;
            return;
          }
        })

        if (newValue !== undefined) {
          return {
            ...field,
            value: newValue,
            errors: []
          }
        }

        return field;
      })

      return Object.assign({}, state, {
        valid: true,
        fields: Array.from(fields)
      })
    }

    case VALIDATE_USER_EDIT_FIELD: {
      return validateField(state, action);
    }

    case SUBMIT_USER_EDIT_FIELDS: {
      return submitFields(state, action);
    }

    case CLEAR_USER_EDIT_FIELDS: {
      return clearFields(state);
    }

    default:
      return state
  }
}
